var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTip2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4693877,32 L6.53061225,32 C2.9387755,32 0,29.0612245 0,25.4693877 L0,6.53061225 C0,2.9387755 2.9387755,0 6.53061225,0 L25.4693877,0 C29.0612245,0 32,2.9387755 32,6.53061225 L32,25.4693877 C32,29.0612245 29.0612245,32 25.4693877,32 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2244898,21.877551 L9.14285716,21.877551 C7.70612247,21.877551 6.53061225,20.7020408 6.53061225,19.2653061 L6.53061225,10.122449 C6.53061225,8.68571428 7.70612247,7.51020409 9.14285716,7.51020409 L21.2244898,7.51020409 C22.6612245,7.51020409 23.8367347,8.68571431 23.8367347,10.122449 L23.8367347,19.2653061 C23.8367347,20.7020408 22.6612245,21.877551 21.2244898,21.877551 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.244898,20.244898 L10.122449,20.244898 C9.04489794,20.244898 8.16326531,19.3632653 8.16326531,18.2857143 L8.16326531,11.1020408 C8.16326531,10.0244898 9.04489797,9.14285716 10.122449,9.14285716 L20.244898,9.14285716 C21.322449,9.14285716 22.2040816,10.0244898 22.2040816,11.1020408 L22.2040816,18.2857143 C22.2040816,19.3632653 21.322449,20.244898 20.244898,20.244898 L20.244898,20.244898 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4489796,14.5306122 C10.4489121,14.9389608 10.6667246,15.3163193 11.0203536,15.5205131 C11.3739826,15.7247068 11.8096909,15.7247068 12.1633199,15.5205131 C12.5169488,15.3163193 12.7347614,14.9389608 12.7346939,14.5306122 C12.7347614,14.1222637 12.5169488,13.7449052 12.1633199,13.5407114 C11.8096909,13.3365177 11.3739826,13.3365177 11.0203536,13.5407114 C10.6667246,13.7449052 10.4489121,14.1222637 10.4489796,14.5306122 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0408163,14.5306123 C14.0408163,15.1617948 14.5524909,15.6734694 15.1836735,15.6734694 C15.814856,15.6734694 16.3265306,15.1617948 16.3265306,14.5306123 C16.3265306,13.8994297 15.814856,13.3877551 15.1836735,13.3877551 C14.5524909,13.3877551 14.0408163,13.8994297 14.0408163,14.5306123 L14.0408163,14.5306123 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.632653,14.5306122 C17.6325855,14.9389608 17.8503981,15.3163193 18.2040271,15.5205131 C18.557656,15.7247068 18.9933644,15.7247068 19.3469933,15.5205131 C19.7006223,15.3163193 19.9184349,14.9389608 19.9183674,14.5306122 C19.9184349,14.1222637 19.7006223,13.7449052 19.3469933,13.5407114 C18.9933644,13.3365177 18.557656,13.3365177 18.2040271,13.5407114 C17.8503981,13.7449052 17.6325855,14.1222637 17.632653,14.5306122 L17.632653,14.5306122 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79591837,21.877551 L9.79591837,23.3469388 C9.79591837,23.8693878 10.3510204,24.1632653 10.7755102,23.9346939 C11.9836735,23.2489796 13.1591837,22.5632653 14.3673469,21.877551 L9.79591837,21.877551 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8367347,16.6530612 L23.8367347,19.2653061 C23.8367347,20.7020408 22.6612245,21.877551 21.2244898,21.877551 L15.6734694,21.877551 L15.6734694,22.8571428 C15.6734694,23.7714286 16.3918367,24.4897959 17.3061224,24.4897959 L20.244898,24.4897959 L22.7918367,26.0244898 C23.1183674,26.2204082 23.5102041,25.9918367 23.5102041,25.6326531 L23.5102041,24.4897959 L23.8367347,24.4897959 C24.7510204,24.4897959 25.4693877,23.7714286 25.4693877,22.8571428 L25.4693877,18.2857143 C25.4693877,17.3714286 24.7510204,16.6530612 23.8367347,16.6530612 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#FFFFFF",
    opacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTip2);
export default __webpack_public_path__ + "static/media/tip2.cd812dba.svg";
export { ForwardRef as ReactComponent };